"use client";

import { useMutation, type UseMutationOptions } from "@tanstack/react-query";

import { deleteSession } from "../kyan.service";

export const useDeleteSession = (options?: UseMutationOptions<boolean>) => {
  return useMutation({
    ...options,
    mutationFn: deleteSession,
  });
};
